import { Injectable } from '@angular/core';

import { environmentOm } from '../../environment-om';

import { Http2, Http2Factory } from './http2-factory';

@Injectable()
export class Api {
    public http2: Http2;
    public report: Http2;
    constructor(public http2Factory: Http2Factory) {
        this.http2 = http2Factory.create(environmentOm.mapcoreApi);
        this.report = http2Factory.create(environmentOm.oneMapApi);
    }

    layerProperties = `
        name,
        id,
        categoryId,
        filter,
        description,
        isGroupLayer,
        labelingInfoJSON,
        sources,
        url,
        symbolsJSON,
        parentId
    `;

    async getLayers(id?: number[], query?: string) {
        const props = query || this.layerProperties;

        return await this.http2.graphqlRequest(`
                query GetLayers($id: [Int]) {
                    layers(id: $id){
                        ${props}
                    }
                }
        `, { id }, 'GET', 'layers');
    }
}

export interface IQuery {
    field?: string;
    operator?: string;
    subqueries?: IQuery[];
    value?: string;
}

export interface IFeature {
    attributes: {
        columnName: string;
        value: string | number;
    }[];
    sourceLayer?: any;
    geometry?: any;
}
